import axios from 'axios'
import { AuthorisationResponse, CreateOrUpdateAuthorisationRequest } from '../../../../api/models'

const baseUrl = process.env.REACT_APP_API_URL

export async function fetchAuthorisationsV2(params: { transitOperationId: number }, opts?: { signal?: AbortSignal }) {
  const { data } = await axios.get<AuthorisationResponse[]>(`${baseUrl}/v2/authorisation/${params.transitOperationId}`, {
    signal: opts?.signal,
  })

  return data
}

export async function createAuthorisationsV2(requests: CreateOrUpdateAuthorisationRequest[]) {
  const { data } = await axios.post<AuthorisationResponse[]>(`${baseUrl}/v2/authorisation`, requests)

  return data
}

export async function updateAuthorisationsV2(requests: CreateOrUpdateAuthorisationRequest[]) {
  const { data } = await axios.put<AuthorisationResponse[]>(`${baseUrl}/v2/authorisation`, requests)

  return data
}

export async function deleteAuthorisation(id: number) {
  await axios.delete<AuthorisationResponse[]>(`${baseUrl}/v2/authorisation/${id}`)
}
